import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { NewActionBadge } from '@sorare/core/src/components/NewActionBadge';
import { Color } from '@sorare/core/src/style/types';

export const DailyRewardBlock = styled(Vertical).attrs({ center: true })`
  height: 100%;
  flex: 1;
  justify-content: center;
`;
export const FullSpaceButton = styled(ButtonBase)`
  width: 100%;
  height: 100%;
`;
export const RewardWrapper = styled(Horizontal)`
  justify-content: center;
  width: calc(var(--unit) * 8);
  height: calc(var(--unit) * 8);
`;

const Root = styled(Vertical)`
  position: relative;
  height: 100%;
  min-height: 100px;
  min-width: calc(10 * var(--unit));
  border: 1px solid var(--c-nd-200);
  border-radius: var(--double-unit);

  &.disabled {
    opacity: 0.5;
  }

  background: rgba(41, 75, 255, 0.16);
`;
const Body = styled(Horizontal)`
  width: 100%;
  flex: 1;
  padding: var(--unit);
  border-radius: calc(var(--double-unit) - 2px) calc(var(--double-unit) - 2px) 0
    0;

  &.isBox {
    background-color: rgba(var(--c-rgb-rivals-friendlies), 0.15);
  }
`;
const Footer = styled(Vertical).attrs({ gap: 0, center: true })`
  width: 100%;
  height: calc(var(--unit) * 3.5);
  border-radius: 0 0 calc(var(--double-unit) - 2px)
    calc(var(--double-unit) - 2px);
`;
const BadgeWrapper = styled(Horizontal)`
  position: absolute;
  top: calc(-1 * var(--unit));
  right: calc(-1 * var(--unit));
`;

type Props = {
  backgroundColor?: Color;
  buttonColor?: Color;
  borderColor?: Color;
  borderWidth?: number;
  footer?: ReactNode;
  isBox?: boolean;
  disabled?: boolean;
  readyToClaim?: boolean;
};
export const DailyReward = ({
  children,
  footer,
  backgroundColor,
  buttonColor,
  borderColor,
  borderWidth = 1,
  isBox,
  disabled,
  readyToClaim,
}: PropsWithChildren<Props>) => {
  return (
    <Root
      gap={0}
      center
      className={classNames({ disabled, isBox })}
      style={{ borderColor, borderWidth, backgroundColor }}
    >
      {readyToClaim && (
        <BadgeWrapper>
          <NewActionBadge>1</NewActionBadge>
        </BadgeWrapper>
      )}
      <Body className={classNames({ isBox })}>{children}</Body>
      <Footer style={{ backgroundColor: buttonColor }}>{footer}</Footer>
    </Root>
  );
};
